export class Uploader {
    public files_changed_cb: any;  
}